import { render } from "./SectionTitle.vue?vue&type=template&id=1828c1f6"
import script from "./SectionTitle.vue?vue&type=script&lang=ts"
export * from "./SectionTitle.vue?vue&type=script&lang=ts"
script.render = render

export default script